// Länder für Kunden im Rechnungswerkzeug: andere EU-Länder (Deutschland ist der Normalfall). Name und Kürzel vor der
// USt-IdNr. (Griechenland: EL). Die Form von PLZ und USt-IdNr. prüft der Server (server/.../rechnungstool/laender.ts).
export const EU_LAENDER: [code: string, name: string, vatPrefix: string][] = [
  ['BE', 'Belgien', 'BE'],
  ['BG', 'Bulgarien', 'BG'],
  ['DK', 'Dänemark', 'DK'],
  ['EE', 'Estland', 'EE'],
  ['FI', 'Finnland', 'FI'],
  ['FR', 'Frankreich', 'FR'],
  ['GR', 'Griechenland', 'EL'],
  ['IE', 'Irland', 'IE'],
  ['IT', 'Italien', 'IT'],
  ['HR', 'Kroatien', 'HR'],
  ['LV', 'Lettland', 'LV'],
  ['LT', 'Litauen', 'LT'],
  ['LU', 'Luxemburg', 'LU'],
  ['MT', 'Malta', 'MT'],
  ['NL', 'Niederlande', 'NL'],
  ['AT', 'Österreich', 'AT'],
  ['PL', 'Polen', 'PL'],
  ['PT', 'Portugal', 'PT'],
  ['RO', 'Rumänien', 'RO'],
  ['SE', 'Schweden', 'SE'],
  ['SK', 'Slowakei', 'SK'],
  ['SI', 'Slowenien', 'SI'],
  ['ES', 'Spanien', 'ES'],
  ['CZ', 'Tschechien', 'CZ'],
  ['HU', 'Ungarn', 'HU'],
  ['CY', 'Zypern', 'CY'],
];

export const vatPrefix = (country: string) => (country === 'DE' ? 'DE' : (EU_LAENDER.find((l) => l[0] === country)?.[2] ?? country));
